/* COLD SCHOOL — global UI behavior */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- Header scroll state + transparent->solid ---- */
 var header = document.querySelector('[data-header]');
if (header) {
  var announcement = document.querySelector('.announcement');
  var onScroll = function () {
    // Logo visibility is handled entirely in CSS via header state classes — no attribute toggling.
    header.classList.toggle('is-scrolled', window.scrollY > 20);
    if (announcement && header.classList.contains('site-header--transparent')) {
      header.style.top = Math.max(0, announcement.offsetHeight - window.scrollY) + 'px';
    }
  };
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
}

  /* ---- Generic open/close for panels ---- */
  function bindPanel(openSel, closeSel, panelSel, cls) {
    var panel = document.querySelector(panelSel);
    if (!panel) return;
    var open = function () {
      panel.classList.add(cls);
      document.documentElement.style.overflow = 'hidden';
      var f = panel.querySelector('button, a, input');
      if (f) f.focus();
    };
    var close = function () {
      panel.classList.remove(cls);
      document.documentElement.style.overflow = '';
    };
    document.querySelectorAll(openSel).forEach(function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); open(); b.setAttribute('aria-expanded', 'true'); });
    });
    panel.querySelectorAll(closeSel).forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    return { open: open, close: close };
  }

  bindPanel('[data-open-nav]', '[data-close-nav]', '[data-mobile-nav]', 'is-open');
  window.CS = window.CS || {};
  window.CS.cartDrawer = bindPanel('[data-open-cart]', '[data-close-cart]', '[data-cart-drawer]', 'is-open');

  /* ---- Accordions ---- */
  document.querySelectorAll('.accordion__trigger').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var panel = btn.parentElement.querySelector('.accordion__panel');
      var open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!open));
      panel.style.maxHeight = open ? '0px' : panel.scrollHeight + 'px';
    });
  });

  /* ---- Reveal on scroll ---- */
  var reveals = document.querySelectorAll('.reveal');
  if (reveals.length && !reduce && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    reveals.forEach(function (el) { io.observe(el); });
  } else {
    reveals.forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* ---- Size-guide + generic modal triggers ---- */
  document.querySelectorAll('[data-modal-open]').forEach(function (btn) {
    var modal = document.getElementById(btn.getAttribute('data-modal-open'));
    if (!modal) return;
    var close = function () { modal.classList.remove('is-open'); document.documentElement.style.overflow = ''; };
    btn.addEventListener('click', function () { modal.classList.add('is-open'); document.documentElement.style.overflow = 'hidden'; });
    modal.querySelectorAll('[data-modal-close], .modal__scrim').forEach(function (c) { c.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  });

  /* ---- Sticky mobile add-to-cart (PDP) ---- */
  var sticky = document.querySelector('[data-sticky-atc]');
  var atcAnchor = document.querySelector('[data-atc-anchor]');
  if (sticky && atcAnchor && 'IntersectionObserver' in window) {
    var so = new IntersectionObserver(function (entries) {
      sticky.classList.toggle('is-visible', !entries[0].isIntersecting);
    }, { rootMargin: '0px' });
    so.observe(atcAnchor);
  }
})();
